import { DEFAULT_LOCALE } from '@/constants/common'

const isCurrentYear = date => {
  const currentDate = new Date()
  return date.getFullYear() === currentDate.getFullYear()
}

export function localizedDateTimeString(date) {
  const year = isCurrentYear(date) ? undefined : { year: 'numeric' }
  return date.toLocaleString(DEFAULT_LOCALE, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    ...year
  })
}

export function localizedDateString(date) {
  const year = isCurrentYear(date) ? undefined : { year: 'numeric' }
  return date.toLocaleDateString(DEFAULT_LOCALE, {
    month: 'short',
    day: 'numeric',
    ...year
  })
}
